import { matchPath, useLocation, useParams } from 'react-router-dom'

export function useParamFromRoute(paramName: string): string {
  const params = useParams<Record<string, string>>()
  return params[paramName] ?? ''
}

export function useRouteMatch(routes: string[]): string | undefined {
  const { pathname } = useLocation()

  return matchPath(pathname, routes)?.path
}
